import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { SubscriptionPerformance } from '../../../_models';
import { SubscriptionPerformanceService, NotificationService, KeywordService } from '../../../_services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-subscription-performance',
  templateUrl: './subscription-performance.component.html'
})
export class SubscriptionPerformanceComponent implements OnInit {
  dateTypeList = { "0": "Subscribe Date", "1": "Unsubscribe Date" };
  reportTypeList = { "By ShortCode": 2, "By Client": 1, "By Spider Account": 3 };

  filterable = {
    from: null,
    to: null,
    dateType: "0",
    reportType: 2,
    source: null,
    country: null,
    operator: null,
    shortCode: null,
    realtime: false
  };

  requestParams = {};

  sourceList = [];
  countryList: any = {};
  operatorList = {};
  shortCodeList = [];
  loading = false;
  processing = false;
  exporting = false;
  totalItems = 0;
  emptyResult = true;
  subsReportLength = 0;
  reports = [];
  isClient = false;
  subscriptions: SubscriptionPerformance[];

  downloadUrl = '';
  headingValues = [];

  allShortCodes = [];
  targetShortCode = null;

  realtimeFlags = { 'Realtime': true, 'Offline': false };
  resultName = '';

  constructor(
    private router: Router,
    private subscriptionSvc: SubscriptionPerformanceService,
    private keywordSvc: KeywordService,
    private notification: NotificationService,
    private route: ActivatedRoute,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    dte.setDate(dte.getDate() - 1);
    this.filterable.to = dte.toISOString().substring(0, 10);
    dte.setDate(dte.getDate() - 7);
    this.filterable.from = dte.toISOString().substring(0, 10);
    this.loadSources();
    // let columns = this.isClient ? 1 : 4;
    // this.search();
    this.loadAllShortCodes();
  }

  search() {
    this.emptyResult = false;
    this.loadPage();
  }

  hiddenFlag = false;

  isDisplay(allZero) {
    return !allZero || !this.hiddenFlag
  }

  export() {
    this.exporting = true;
    let params = this.formParam();
    this.subscriptionSvc.export(params, this.filterable.realtime)
      .subscribe(res => {
        this.downloadUrl = res.data;
        document.getElementById('download').click();
        this.exporting = false;
      });
  }

  openModal(targetModal) {
    this.modalService.open(targetModal, {
      windowClass: 'modal-holder',
      size: 'lg'
    });
  }

  onClear() {
    this.filterable.shortCode = null;
    this.targetShortCode = null;
  }

  gotoTargetShortCode(targetShortCode) {
    if (targetShortCode) {
      let source = this.sourceList.find(it => { return it.value == targetShortCode.source });
      this.changeSource(source, targetShortCode);
    }
  }

  changeSource(source, targetShortCode = null) {
    if (!targetShortCode) {
      this.targetShortCode = null;
    }
    this.filterable.source = source;
    this.shortCodeList = [];
    this.countryList = {};
    this.operatorList = {};
    this.filterable.shortCode = null;
    this.filterable.operator = null;
    this.filterable.country = null;
    if (source) {
      this.countryList = source.subOptions;
      var targetCountry;
      if (targetShortCode) {
        targetCountry = targetShortCode.country;
      } else {
        targetCountry = this.countryList[Object.keys(this.countryList)[0]];
      }
      this.changeCountry(targetCountry, targetShortCode);
    }
  }

  changeCountry(country, targetShortCode = null) {
    if (!targetShortCode) {
      this.targetShortCode = null;
    }
    this.filterable.country = country;
    this.shortCodeList = [];
    this.operatorList = {};
    this.filterable.shortCode = null;
    this.filterable.operator = null;
    if (country) {
      this.keywordSvc.getSelectionShortCodes(this.filterable.source.value, country).subscribe(data => {
        this.operatorList = data.data;
        if (targetShortCode) {
          this.changeOperator(targetShortCode.operator, targetShortCode);
        }
      });
    }
  }

  changeOperator(operator, targetShortCode = null) {
    if (!targetShortCode) {
      this.targetShortCode = null;
    }
    this.filterable.operator = operator;
    this.shortCodeList = [];
    this.filterable.shortCode = null;
    if (operator) {
      this.shortCodeList = this.operatorList[operator];
      if (targetShortCode) {
        this.changeShortCode(targetShortCode.shortCode, targetShortCode);
      }
    }
  }

  changeShortCode(shortCode, targetShortCode = null) {
    this.filterable.shortCode = shortCode;
    if (!targetShortCode) {
      this.targetShortCode = this.allShortCodes.find(it => { return it.shortCode == this.filterable.shortCode && it.operator == this.filterable.operator });
    }
  }

  private loadSources() {
    this.keywordSvc.getSelectionSources().pipe(first()).subscribe(data => {
      this.sourceList = data.data;
      let currentSource = this.sourceList.find(it => it.name == 'PAY365');
      if(!currentSource){
        currentSource = data.data[0];
      }
      this.filterable.source = currentSource;
      this.countryList = currentSource.subOptions;
      var key = Object.keys(currentSource.subOptions)[0];
      var value = currentSource.subOptions[key];
      this.filterable.country = value;
      this.changeCountry(this.filterable.country);
    });
  }

  private loadAllShortCodes() {
    this.keywordSvc.allShortCodeForSelection().pipe(first()).subscribe(data => {
      if (data) {
        this.allShortCodes = data.data;
      }
    });
  }

  private loadPage() {
    this.loading = true;
    this.subscriptions = [];
    this.subsReportLength = 0;
    this.totalItems = 0;
    this.reports = null;
    this.requestParams = this.formParam();
    this.requestParams['realtime'] = this.filterable.realtime;

    this.resultName = this.filterable.realtime ? 'Realtime' : 'Offline';
    // get page of items from api
    this.subscriptionSvc.getAll(this.requestParams, this.filterable.realtime).pipe(first()).subscribe(data => {
      if (data !== null && data.data.length > 0) {
        this.loading = false;
        this.emptyResult = false;
        this.subscriptions = data.data;
        this.totalItems = data.data.length;
        this.subsReportLength = this.subscriptions[0].reports.length;
        this.reports = this.subscriptions[0].reports;
      } else {
        this.loading = false;
        this.emptyResult = true;
        this.notification.showWarning("There is no report for this subscription.", "Empty Result");
      }
    });
  }

  private formParam() {
    let params = {
      from: formatDate(this.filterable.from, 'yyyyMMdd', 'en'),
      to: formatDate(this.filterable.to, 'yyyyMMdd', 'en'),
      dateType: this.filterable.dateType,
      reportType: this.filterable.reportType,
      source: this.filterable.source.value,
      country: this.filterable.country,
      operator: this.filterable.operator,
      shortCode: this.filterable.shortCode,
    }
    return params;
  }

}
